import AkSelect from '@atlaskit/select';
import { Country as CountryType } from '../../data/countries/model';
import React, { useEffect, useState } from 'react';
import { Field } from '@atlaskit/form';
import t from '../../i18n/intl';
import styled from 'styled-components';

export const Select = styled(AkSelect)`
  input::-webkit-contacts-auto-fill-button {
    display: none !important;
  }
`;

type StateProvinceSelectProps = {
  countryDetails?: CountryType | null;
  state?: string | null;
  onSelectState: (state: { name: string; code: string } | null) => void;
};

type SelectOption = {
  name: string;
  code: string;
};

export const StateProvince: React.FC<StateProvinceSelectProps> = (
  props: StateProvinceSelectProps,
) => {
  const { state: currentStateCode, countryDetails, onSelectState } = props;
  const preselectedState =
    countryDetails?.states?.find((state: SelectOption) => state.code === currentStateCode) || null;
  const [stateValue, setStateValue] = useState<SelectOption | null>(preselectedState);

  useEffect(() => {
    setStateValue(preselectedState);
    onSelectState(preselectedState);
  }, [currentStateCode]);

  useEffect(() => {
    if (countryDetails?.states) {
      setStateValue(preselectedState);
      onSelectState(preselectedState);
    }
  }, [countryDetails]);

  const isStateInCountry = countryDetails?.states?.find(
    (state: SelectOption) => state.code === stateValue?.code,
  );

  useEffect(() => {
    if (!isStateInCountry) {
      setStateValue(null);
      onSelectState(null);
    }
  }, [isStateInCountry]);

  const handleChangeState = (state) => {
    setStateValue(state);
    onSelectState(state);
  };

  return (
    <Field
      name="state"
      label={t('mac.edit-details.org.contact.state')}
      isRequired
      validate={handleChangeState}
      defaultValue={stateValue}
    >
      {({ fieldProps }) => (
        <Select
          hasAutocomplete
          options={countryDetails?.states || []}
          getOptionLabel={(s: SelectOption) => s.name}
          getOptionValue={(s: SelectOption) => s.code}
          {...fieldProps}
        />
      )}
    </Field>
  );
};
